import html2pdf from 'html2pdf.js';
import { notify } from './api';
async function dataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader(); reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Impossibile leggere l’immagine.')); reader.readAsDataURL(blob);
  });
}
export async function generatePDF(element) {
  if (!element) throw new Error('Apri il menu prima di creare il PDF.');
  const shell = document.createElement('div');
  shell.className = 'pdf-export-shell';
  const clone = element.cloneNode(true);
  clone.removeAttribute('id'); clone.classList.add('pdf-mode');
  clone.querySelectorAll('button, .menu-footer, .screen-only, .image-placeholder').forEach(x => x.remove());
  shell.appendChild(clone); document.body.appendChild(shell);
  let missing = 0;
  try {
    for (const img of clone.querySelectorAll('img')) {
      try {
        if (!img.src.startsWith('data:')) {
          const response = await fetch(img.src, { signal: AbortSignal.timeout(15000) });
          if (!response.ok) throw new Error();
          img.src = await dataUrl(await response.blob());
        }
        await img.decode();
      } catch { img.remove(); missing++; }
    }
    if (document.fonts?.ready) await document.fonts.ready;
    const blob = await html2pdf().set({
      margin: [12, 12, 12, 12], filename: 'menu_ricevimento.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 2, backgroundColor: '#ffffff', useCORS: true, logging: false, windowWidth: 794 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
      pagebreak: { mode: ['css', 'legacy'], avoid: ['.menu-item'] }
    }).from(clone).outputPdf('blob');
    if (missing) notify('Alcune immagini non sono disponibili: il PDF contiene i testi e le immagini caricabili.', 'warning');
    return blob;
  } finally { shell.remove(); }
}
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob); const link = document.createElement('a');
  link.href = url; link.download = filename; link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
}
